import { ComponentType } from "react";
import colors from "../../sass/modules/_colors.module.scss";

export interface IconProps {
    size?: string;
    colour?: string;
    secondaryColour?: string;
    type?: "filled" | "outlined";
    className?: string;
    title?: string;
    ariaHidden?: boolean;
}

export interface IconComponent extends IconProps {
    name: string;
}

export interface IconComponentObject {
    [key: string]: ComponentType<IconProps>;
}

interface IIconColours {
    [key: string]: string;
}

const IconColours: IIconColours = {};

Object.keys(colors).forEach((key) => {
    IconColours[key] = colors[key];
});
export { IconColours };
